import { ColumnLabelStyled } from "./column-label.styles";

const ColumnLabel = ({ children }) => {
    return <ColumnLabelStyled>{children}</ColumnLabelStyled>;
};

export default ColumnLabel;
